<div class="header">
	<div class="type">
		<span>
			<strong> {{ "syncActions.type" | translate }}: </strong>
			<span>{{ "app_events." + appEvent().type | translate }}</span>
		</span>

		<span class="show-details" (click)="showDetails.set(!showDetails())">
			<i class="fa" [class.fa-chevron-down]="showDetails()" [class.fa-chevron-up]="!showDetails()"></i>
		</span>
	</div>

	@if (showDetails()) {
		<p class="details">
			<strong>id: </strong>
			<span>{{ appEvent().id }}</span>
		</p>
	}
</div>

<div class="body"></div>

<footer class="muted-footer"></footer>
